import { FETCH_SKU_SEARCH, CLEAR_SKU_SEARCH } from "../actions/types";

export const skuSearchReducer = (state = [], action) => {
  switch (action.type) {
    case FETCH_SKU_SEARCH:
      const arr = [...state];
      arr.push(action.payload);
      return arr;
    case CLEAR_SKU_SEARCH:
      return [];
    default:
      return state;
  }
};
